import { inject, Injectable } from '@angular/core';
import {
  StatusControllerStatusRemoteMethod
} from 'open-api-legacy/remote-methods/status-controller-status.remote-method';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BackendStatusService {
  private readonly getStatus = inject(StatusControllerStatusRemoteMethod);
  public readonly status = new BehaviorSubject<any>(null);

  constructor() {
    this.getStatus.call().then(status => this.status.next({ sms: status['sms'] === "true" }));
  }
}
